<script>
import Head from '@/components/Head';
import Table from '@/components/Table';
import Loader from '@/components/Loader';
import Button from '@/components/Button';
import Input from '@/components/Input';
import Select from '@/components/Select';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import * as XLSX from 'xlsx';

export default {
    props: {
        userData: {
            type: Object
        }
    },
    data() {
        return {
            loader: true,
            jsonData: [],
            loadingTable: true,
            hasNextPage: false,
            itemsPerPage: 10,
            actualPage: 0,
            totalItems: 0,
            editManualHistoryId: undefined,
            cashFlowTableCategories: [
                'ID',
                'Tipo',
                'Data',
                'Valor',
                'Número Documento',
                'Código do Histórico',
                'Histórico',
                'Detalhamento do Histórico',
                'Descrição',
                'Estado do Pagamento',
            ],
            cashFlowItems: [],
            cashFlowItemsFullInfos: [],
            entrySum: 0,
            exitSum: 0,
            totalSum: 0,
            filtersData: {
                initial_date: this.getFirstDateDay(),
                finish_date: this.getCurrentDate(),
            },
            modalManualHistory: false,
            addManualHistoryData: {
                type: "Entrada",
                date: this.getCurrentDate(),
                origin_agency: '',
                allotment: '',
                document_number: '',
                history_code: '',
                history: '',
                history_detail: '',
                value: 0,
                description: '',
            },
            editManualHistoryData: {
                origin_agency: '',
                allotment: '',
                document_number: '',
                history_code: '',
                history: '',
                history_detail: '',
                value: 0,
                description: '',
                transferred_to_user_id: null,
            },
            transferUserSelect: [
                { name: 'Não transferir', value: null }
            ],
            modalSelectTransferUser: false,
            allAssociatesList: [],
            searchTransferUser: '',
            paymentStatusSelect: [
                {
                    name: 'Identificado',
                    value: 1,
                    selected: false,
                },
                {
                    name: 'Não identificado',
                    value: 0,
                    selected: false,
                },
            ],
            typeSelectManualHistory: [
                {
                    name: 'Entrada',
                    value: 'Entrada',
                    selected: true
                },
                {
                    name: 'Saida',
                    value: 'Saida',
                    selected: false
                },
            ],
            selectedUploadStatementFile: null,
            cashFlowTableActions: [
                'pencil-square'
            ],
            uploadType: undefined,
        }
    },
    created() {
        if (this.userData.role == 'associate') {
            this.$router.push('/inicio');
        }

        const { initial_date, finish_date } = this.$route.query;

        if (initial_date) {
            this.filtersData.initial_date = initial_date; // Define o valor se estiver presente
        }

        if (finish_date) {
            this.filtersData.finish_date = finish_date; // Define o valor se estiver presente
        }

        this.getNextCashFlow();
        this.loadAllAssociatesForTransfer();
    },
    methods: {
        notify(text, type) {
            toast(text, {
                "type": type == 'info' ? 'info' : type == 'warning' ? 'warning' : type == 'error' ? 'error' : type == 'success' ? 'success' : 'default',
            });
        },
        getFirstDateDay() {
            const currentDate = new Date();
            const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
            
            const formatDate = (date) => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }

            return formatDate(firstDayOfMonth);
        },
        getCurrentDate() {
            var data = new Date();

            var year = data.getFullYear();
            var monthly = ('0' + (data.getMonth() + 1)).slice(-2);
            var day = ('0' + data.getDate()).slice(-2);

            var formatedDate = year + '-' + monthly + '-' + day;
            return formatedDate;
        },
        loadAllAssociatesForTransfer() {
            console.log('Carregando todos os associados para transferência');
            this.$axios.get('/associates/get-all-active')
            .then(res => {
                console.log('Associados carregados:', res.data);
                if (res.data.data) {
                    this.allAssociatesList = res.data.data;
                }
            })
            .catch(err => {
                console.log('Erro ao carregar associados:', err);
                this.allAssociatesList = [];
            });
        },
        openSelectTransferUserModal() {
            this.modalSelectTransferUser = true;
            if (this.allAssociatesList.length === 0) {
                this.loadAllAssociatesForTransfer();
            }
        },
        closeSelectTransferUserModal() {
            this.modalSelectTransferUser = false;
            this.searchTransferUser = '';
        },
        selectTransferUser(user) {
            console.log('Selecionando usuário para transferência:', user);
            this.editManualHistoryData.transferred_to_user_id = user.id;
            this.closeSelectTransferUserModal();
            this.notify(`Associado selecionado: ${user.name}`, 'success');
        },
        removeTransferUser() {
            this.editManualHistoryData.transferred_to_user_id = null;
            this.notify('Associado removido', 'info');
        },
        getTransferUserName(userId) {
            if (!userId) return '';
            const user = this.allAssociatesList.find(u => u.id === userId);
            return user ? user.name : 'Carregando...';
        },
        getRecoverFilter() {
            this.loader = true;

            this.actualPage = 0;
            this.totalItems = 0;
            this.cashFlowItems = [];

            this.loadingTable = true;

            const showNotIdentified = this.$route.query.show_not_identified === 'true';
            const endpoint = showNotIdentified 
                ? `/cash_flow/not_identified?initial_date=${this.filtersData.initial_date}&finish_date=${this.filtersData.finish_date}&items_per_page=${this.itemsPerPage}`
                : `/cash_flow?initial_date=${this.filtersData.initial_date}&finish_date=${this.filtersData.finish_date}&items_per_page=${this.itemsPerPage}&page=${this.actualPage + 1}`;

            this.$axios.get(endpoint)
            .then(res => {
                console.log(res);
                if (!res.data.data) {
                    return this.notify('Ocorreu um erro ao buscar o histórico do fluxo de caixa!', 'error')
                };

                const data = res.data.data;

                this.actualPage += 1;
                
                this.totalItems = data.data.total;

                data.data.next_page_url == null ? this.hasNextPage = false : this.hasNextPage = true;

                this.entrySum = showNotIdentified ? data.total_value : data.entry_sum;
                this.exitSum = showNotIdentified ? 0 : data.exit_sum;
                this.totalSum = showNotIdentified ? data.total_value : data.final_sum;

                data.data.data.forEach((item) => {
                    let cashFlows = [];

                    cashFlows.push(item.id);
                    cashFlows.push(item.type);
                    cashFlows.push(`${item.date[8]}${item.date[9]}/${item.date[5]}${item.date[6]}/${item.date[0]}${item.date[1]}${item.date[2]}${item.date[3]}`);
                    cashFlows.push(`R$ ${item.value.replace('.', ',')}`);
                    cashFlows.push(item.document_number);
                    cashFlows.push(item.history_code);
                    cashFlows.push(item.history);
                    cashFlows.push(item.history_detail);
                    cashFlows.push(item.description);
                    cashFlows.push(item.is_correct);

                    this.cashFlowItems.push(cashFlows);
                    this.cashFlowItemsFullInfos.push(item);
                });

                this.loader = false;
            })
            .catch(err => {
                this.loader = false;
                return this.notify('Ocorreu um erro ao buscar o histórido do fluxo de caixa.', 'error');
            });
        },
        getNextCashFlow() {
            this.loadingTable = true;

            const showNotIdentified = this.$route.query.show_not_identified === 'true';
            const endpoint = showNotIdentified 
                ? `/cash_flow/not_identified?initial_date=${this.filtersData.initial_date}&finish_date=${this.filtersData.finish_date}&items_per_page=${this.itemsPerPage}`
                : `/cash_flow?initial_date=${this.filtersData.initial_date}&finish_date=${this.filtersData.finish_date}&items_per_page=${this.itemsPerPage}&page=${this.actualPage + 1}`;

            this.$axios.get(endpoint)
            .then(res => {
                console.log(res);
                if (!res.data.data) {
                    return this.notify('Ocorreu um erro ao buscar o histórico do fluxo de caixa!', 'error')
                };

                const data = res.data.data;

                this.actualPage += 1;
                
                this.totalItems = data.data.total;

                data.data.next_page_url == null ? this.hasNextPage = false : this.hasNextPage = true;

                this.entrySum = showNotIdentified ? data.total_value : data.entry_sum;
                this.exitSum = showNotIdentified ? 0 : data.exit_sum;
                this.totalSum = showNotIdentified ? data.total_value : data.final_sum;

                data.data.data.forEach((item) => {
                    let cashFlows = [];

                    cashFlows.push(item.id);
                    cashFlows.push(item.type);
                    cashFlows.push(`${item.date[8]}${item.date[9]}/${item.date[5]}${item.date[6]}/${item.date[0]}${item.date[1]}${item.date[2]}${item.date[3]}`);
                    cashFlows.push(`R$ ${item.value.replace('.', ',')}`);
                    cashFlows.push(item.document_number);
                    cashFlows.push(item.history_code);
                    cashFlows.push(item.history);
                    cashFlows.push(item.history_detail);
                    cashFlows.push(item.description);
                    cashFlows.push(item.is_correct);

                    this.cashFlowItems.push(cashFlows);
                    this.cashFlowItemsFullInfos.push(item);
                });

                this.loader = false;
            })
            .catch(err => {
                this.loader = false;
                return this.notify('Ocorreu um erro ao buscar o histórido do fluxo de caixa.', 'error');
            });
        },
        addCashFlow() {
            this.loader = true;

            this.$axios.post('/cash_flow', this.addManualHistoryData)
            .then(res => {
                this.notify('Histórico adicionado com sucesso!', 'success');

                this.$router.push({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        initial_date: this.filtersData.initial_date,
                        finish_date: this.filtersData.finish_date,
                    }
                });

                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            })
            .catch(err => {
                this.notify('Ocorreu um erro ao tentar adicionar um histórico novo.', 'error');
                this.loader = false;
            });
        },
        closeModalManualHistory() {
            this.addManualHistoryData = {
                type: "Entrada",
                date: this.getCurrentDate(),
                origin_agency: '',
                allotment: '',
                document_number: '',
                history_code: '',
                history: '',
                history_detail: '',
                value: 0,
                description: '',
            };

            this.modalManualHistory = false;
        },
        loadStatement() {
            const input = document.getElementById("upload-statements");
            
            input.click();
        },
        uploadStatementFile(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedUploadStatementFile = file;
            } else {
                console.error('No file selected');
            }
        },
        sendStatement() {
            console.log('comecou')
            var file = this.selectedUploadStatementFile;

            if (this.uploadType == 'billet') {
                console.log("boleto");
                const reader = new FileReader();
                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });

                    // Considerando que os dados estão na primeira planilha
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];

                    // Converte a planilha em JSON
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);

                    this.jsonData = jsonData;

                    console.log(this.jsonData);

                    this.sendBilletDataToApi();
                };
                reader.readAsArrayBuffer(file);
            }

            if (this.uploadType == 'extract') {
                console.log("extrato")
                const reader = new FileReader();
                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });

                    // Considerando que os dados estão na primeira planilha
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];

                    // Converte a planilha em JSON
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);

                    this.jsonData = jsonData;

                    console.log(this.jsonData);

                    this.sendDataToApi();
                };
                reader.readAsArrayBuffer(file);
            }

            if (this.uploadType == 'ofx') {
                console.log("ofx");
                const reader = new FileReader();
                reader.onload = (e) => {
                    const ofxContent = e.target.result;
                    console.log('OFX Content:', ofxContent);
                    this.sendOFXDataToApi(ofxContent);
                };
                reader.readAsText(file);
            }
        },
        async sendBilletDataToApi() {
            this.notify('Estamos fazendo a leitura do seu extrato, aguarde finalizar!', 'info');
            this.loader = true;
            console.log('foi chamado - boleto')

            this.$axios.post('cash_flow/read_extract_billet', this.jsonData)
            .then(res => {
                this.notify('Extrato lido com sucesso!', 'success');

                this.$router.push({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        initial_date: this.filtersData.initial_date,
                        finish_date: this.filtersData.finish_date,
                    }
                });

                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            })
        },
        async sendOFXDataToApi(ofxContent) {
            this.notify('Estamos fazendo a leitura do seu extrato OFX, aguarde finalizar!', 'info');
            this.loader = true;
            console.log('foi chamado - ofx')

            this.$axios.post('cash_flow/read_extract_ofx', { ofx_content: ofxContent })
            .then(res => {
                if (res.data.data && res.data.data.errors > 0) {
                    this.notify(`OFX processado! ${res.data.data.processed} transações importadas, ${res.data.data.errors} não identificadas.`, 'warning');
                } else {
                    this.notify('OFX processado com sucesso!', 'success');
                }

                this.$router.push({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        initial_date: this.filtersData.initial_date,
                        finish_date: this.filtersData.finish_date,
                    }
                });

                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            })
            .catch(err => {
                this.notify('Erro ao processar OFX: ' + (err.response?.data?.message || err.message), 'error');
                this.loader = false;
            });
        },
        showNotIdentified() {
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    initial_date: this.filtersData.initial_date,
                    finish_date: this.filtersData.finish_date,
                    show_not_identified: 'true'
                }
            });

            setTimeout(() => {
                window.location.reload();
            }, 500);
        },
        async sendDataToApi() {
            this.notify('Estamos fazendo a leitura do seu extrato, aguarde finalizar!', 'info');
            this.loader = true;
            console.log('foi chamado')
            const chunkSize = 50;
            for (let i = 0; i < this.jsonData.length; i += chunkSize) {
                const chunk = this.jsonData.slice(i, i + chunkSize);
                await this.sendChunk(chunk);
                await this.delay(5000);
            }

            this.$router.push({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        initial_date: this.filtersData.initial_date,
                        finish_date: this.filtersData.finish_date,
                    }
                });

            this.notify('Extrato lido com sucesso!', 'success');

            setTimeout(() => {
                window.location.reload();
            }, 4000);
        },
        async sendChunk(chunk) {
            console.log('começando apis')
            try {
                const response = await this.$axios.post('/cash_flow/read_extract', chunk);
                console.log('Lote enviado com sucesso:', response.data);
            } catch (error) {
                console.error('Erro ao enviar lote:', error);
            }
        },
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        cashFlowTableClickAction(event) {
            if (event.eventType == 'pencil-square') {
                console.log(event);
                console.log(this.cashFlowItemsFullInfos);
                for (let i = 0; i < this.cashFlowItemsFullInfos.length; i++) {
                    if (this.cashFlowItemsFullInfos[i].id === event.data[0]) {
                        const cashFlowItem = this.cashFlowItemsFullInfos[i];
                        // Criar um novo objeto com todas as propriedades necessárias
                        this.editManualHistoryData = {
                            origin_agency: cashFlowItem.origin_agency,
                            allotment: cashFlowItem.allotment,
                            document_number: cashFlowItem.document_number,
                            history_code: cashFlowItem.history_code,
                            history: cashFlowItem.history,
                            history_detail: cashFlowItem.history_detail,
                            value: cashFlowItem.value,
                            description: cashFlowItem.description,
                            is_correct: cashFlowItem.is_correct,
                            transferred_to_user_id: null,
                        };
                        this.editManualHistoryId = cashFlowItem.id;
                        console.log('Dados carregados para edição:', this.editManualHistoryData);
                    }
                }
                
                this.paymentStatusSelect = [
                    {
                        name: 'Identificado',
                        value: 1,
                        selected: this.editManualHistoryData.is_correct == 1 ? true : false,
                    },
                    {
                        name: 'Não identificado',
                        value: 0,
                        selected: this.editManualHistoryData.is_correct == 0 ? true : false,
                    },
                ];
            }


            this.modalManualHistoryType = 'edit';
            this.modalManualHistory = true;
        },
        editCashFlow() {
            this.loader = true;

            console.log('=== INICIO EDIÇÃO ===');
            console.log('Enviando dados para edição:', JSON.stringify(this.editManualHistoryData, null, 2));
            console.log('ID do usuário selecionado:', this.editManualHistoryData.transferred_to_user_id);
            console.log('Tipo do ID:', typeof this.editManualHistoryData.transferred_to_user_id);

            // Alerta para o usuário ver o que está sendo enviado
            const userId = this.editManualHistoryData.transferred_to_user_id;
            const userName = userId ? this.getTransferUserName(userId) : 'Nenhum';
            
            if (!confirm(`CONFIRME:\n\nAssociado selecionado: ${userName}\nID: ${userId || 'null'}\n\nDeseja continuar?`)) {
                this.loader = false;
                return;
            }

            this.$axios.put(`/cash_flow/${this.editManualHistoryId}`, this.editManualHistoryData)
            .then(res =>  {
                console.log('=== RESPOSTA DO SERVIDOR ===');
                console.log('Resposta completa:', res);
                console.log('Resposta data:', res.data);
                this.notify('Dados atualizados com sucesso!', 'success');

                setTimeout(() => {
                    this.$router.push({
                        path: this.$route.path,
                        query: {
                            ...this.$route.query,
                            initial_date: this.filtersData.initial_date,
                            finish_date: this.filtersData.finish_date,
                        }
                    });
                    
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                }, 3000);
            })
            .catch(err => {
                console.error('=== ERRO NA EDIÇÃO ===');
                console.error('Erro completo:', err);
                console.error('Erro response:', err.response);
                console.error('Erro data:', err.response?.data);
                this.notify('Ocorreu um erro durante a atualização dos dados e não foi possível finalizar!', 'error');

                this.loader = false;
            })
        }
    },
    components: { Head, Table, Button, Input, Select, Loader }
}
</script>

<template>
    <Loader v-if="loader" />

    <section v-if="modalManualHistory" class="bg-add-associate">
        <Head :title="modalManualHistoryType == 'add' ? `Adicionar histórico manual` : `Editar histórico`" />

        <div @click="closeModalManualHistory" class="close-add-associate">
            x
        </div>

        <section v-if="modalManualHistoryType == 'edit'" class="form-add-associate">
            <div class="form-add-associate-line">
                <Input type="text" label="Agência de origem" placeholder="0001" :value="editManualHistoryData.origin_agency" v-model="editManualHistoryData.origin_agency" :onlyNumbers="true" />
            </div>

            <div class="form-add-associate-line">
                <Input type="text" label="Lote" placeholder="54875" :value="editManualHistoryData.allotment" v-model="editManualHistoryData.allotment" :onlyNumbers="true" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Número do documento" placeholder="54875" :value="editManualHistoryData.document_number" v-model="editManualHistoryData.document_number" :onlyNumbers="true" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Código do histórico" placeholder="877" :value="editManualHistoryData.history_code" v-model="editManualHistoryData.history_code" :onlyNumbers="true" />
            </div>

            <div class="form-add-associate-line">
                <Input type="text" label="Valor" placeholder="200.00" :value="editManualHistoryData.value" v-model="editManualHistoryData.value" :currencyMask="true" />
                <div class="form-add-associate-line-space"></div>
                <Select label="Estado do Pagamento" :options="paymentStatusSelect" :value="editManualHistoryData.is_correct" v-model="editManualHistoryData.is_correct" />
            </div>

            <div class="form-add-associate-line">
                <Input type="text" label="Descrição" placeholder="Recebimento de mensalidade de Fulano Ciclano" :value="editManualHistoryData.description" v-model="editManualHistoryData.description" />
            </div>

            <div class="form-add-associate-line">
                <div class="form-add-associate-full-width">
                    <label class="label-select-user">Transferir para associado (opcional):</label>
                    <div class="selected-user-display" v-if="editManualHistoryData.transferred_to_user_id">
                        <span>{{ getTransferUserName(editManualHistoryData.transferred_to_user_id) }}</span>
                        <button type="button" @click="removeTransferUser()" class="btn-remove-user">✕</button>
                    </div>
                    <button v-else type="button" @click="openSelectTransferUserModal()" class="btn-select-user">
                        Selecionar Associado
                    </button>
                </div>
            </div>

            <div class="form-add-associate-button">
                <Button type="primary" placeholder="Editar histórico" @buttonPressed="editCashFlow" />
            </div>
        </section>

        <section v-if="modalManualHistoryType == 'add'" class="form-add-associate">
            <div class="form-add-associate-line">
                <Select label="Tipo" :options="typeSelectManualHistory" :value="addManualHistoryData.type" v-model="addManualHistoryData.type" />
                <div class="form-add-associate-line-space"></div>
                <Input type="date" label="Data" placeholder="10/01/2023" :value="addManualHistoryData.date" v-model="addManualHistoryData.date" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Agência de origem" placeholder="0001" :value="addManualHistoryData.origin_agency" v-model="addManualHistoryData.origin_agency" :onlyNumbers="true" />
            </div>

            <div class="form-add-associate-line">
                <Input type="text" label="Lote" placeholder="54875" :value="addManualHistoryData.allotment" v-model="addManualHistoryData.allotment" :onlyNumbers="true" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Número do documento" placeholder="54875" :value="addManualHistoryData.document_number" v-model="addManualHistoryData.document_number" :onlyNumbers="true" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Código do histórico" placeholder="877" :value="addManualHistoryData.history_code" v-model="addManualHistoryData.history_code" :onlyNumbers="true" />
            </div>

            <div class="form-add-associate-line">
                <Input type="text" label="Histórico" placeholder="Transferência recebida" :value="addManualHistoryData.history" v-model="addManualHistoryData.history" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Detalhamento do histórico" placeholder="02/01 10:20 FULANO CICLANO" :value="addManualHistoryData.history_detail" v-model="addManualHistoryData.history_detail" />
                <div class="form-add-associate-line-space"></div>
                <Input type="text" label="Valor" placeholder="200.00" :value="addManualHistoryData.value" v-model="addManualHistoryData.value" :currencyMask="true" />
            </div>

            <div class="form-add-associate-line">
                <Input type="text" label="Descrição" placeholder="Recebimento de mensalidade de Fulano Ciclano" :value="addManualHistoryData.description" v-model="addManualHistoryData.description" />
            </div>

            <div class="form-add-associate-button">
                <Button type="primary" placeholder="Adicionar histórico" @buttonPressed="addCashFlow" />
            </div>
        </section>
    </section>

    <section class="bg-cash-flow">
        <Head title="Fluxo de Caixa" />

        <section class="actions">
            <Button type="primary" placeholder="Carregar extrato" class="btn" @buttonPressed="loadStatement" @click="uploadType = 'extract'" />
            <div class="form-line-space"></div>
            <Button type="primary" placeholder="Carregar extrato boleto" class="btn" @buttonPressed="loadStatement" @click="uploadType = 'billet'" />
            <div class="form-line-space"></div>
            <Button type="primary" placeholder="Carregar OFX" class="btn" @buttonPressed="loadStatement" @click="uploadType = 'ofx'" />
            <div class="form-line-space"></div>
            <Button type="primary" placeholder="Histórico manual" class="btn" @buttonPressed="modalManualHistoryType = 'add'; modalManualHistory = true" />
            <div class="form-line-space"></div>
            <Button type="secondary" placeholder="Ver não identificados" class="btn" @buttonPressed="showNotIdentified" />
            <div class="form-line-space"></div>
            <div v-if="selectedUploadStatementFile" class="search-button">
                <Button type="secondary" class="btn" @buttonPressed="sendStatement">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
                    </svg>
                </Button>
            </div>

            <input @change="uploadStatementFile" type="file" name="upload-statement" id="upload-statements" accept=".xlsx,.ofx" style="display:none">
        </section>

        <section class="filters">
            <Input type="date" label="Desde:" placeholder="10/01/2023" :value="filtersData.initial_date" v-model="filtersData.initial_date" />
            <div class="form-line-space"></div>
            <Input type="date" label="Até:" placeholder="10/01/2023" :value="filtersData.finish_date" v-model="filtersData.finish_date" />
            <div class="form-line-space"></div>
            <Button type="primary" placeholder="Filtrar" class="btn" @buttonPressed="getRecoverFilter" />
        </section>

        <section v-if="!loader" class="bg-cards">
            <div class="card">
                <h2>Entradas</h2>
                <p class="green">R$ {{ parseFloat(entrySum).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</p>
            </div>

            <div class="card">
                <h2>Saídas</h2>
                <p class="red">R$ {{ parseFloat(exitSum).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</p>
            </div>

            <div class="card">
                <h2>Valor total</h2>
                <p class="blue">R$ {{ parseFloat(totalSum).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) }}</p>
            </div>
        </section>

        <Table v-if="!loader" :hasActions="true" :actions="cashFlowTableActions" :hasNextPage="hasNextPage" :headers="cashFlowTableCategories" :contents="cashFlowItems" @loadMore="getNextCashFlow" @clickAction="cashFlowTableClickAction" :hasIsCorrect="true" />
    </section>

    <!-- Modal de Seleção de Associado para Transferência -->
    <section v-if="modalSelectTransferUser" class="bg-add-associate modal-select-paid-user">
        <Head title="Selecionar Associado para Transferência" />

        <div @click="closeSelectTransferUserModal" class="close-add-associate">
            x
        </div>

        <section class="form-add-associate select-user-modal">
            <div class="search-user-container">
                <Input 
                    type="text" 
                    label="Pesquisar associado" 
                    placeholder="Digite o nome, CPF ou matrícula..." 
                    :value="searchTransferUser" 
                    v-model="searchTransferUser" 
                />
            </div>

            <div class="users-list-container">
                <div 
                    v-for="user in allAssociatesList.filter(u => 
                        !searchTransferUser || 
                        u.name.toLowerCase().includes(searchTransferUser.toLowerCase()) ||
                        u.document_cpf.includes(searchTransferUser) ||
                        (u.registration_number && u.registration_number.includes(searchTransferUser))
                    )" 
                    :key="user.id"
                    @click="selectTransferUser(user)"
                    class="user-item"
                >
                    <div class="user-info">
                        <strong>{{ user.name }}</strong>
                        <span class="user-details">CPF: {{ user.document_cpf }} | Matrícula: {{ user.registration_number || 'N/A' }}</span>
                    </div>
                    <button type="button" class="btn-select-this-user">Selecionar</button>
                </div>

                <div v-if="allAssociatesList.length === 0" class="no-users-found">
                    Carregando associados...
                </div>

                <div v-else-if="allAssociatesList.filter(u => 
                    !searchTransferUser || 
                    u.name.toLowerCase().includes(searchTransferUser.toLowerCase()) ||
                    u.document_cpf.includes(searchTransferUser) ||
                    (u.registration_number && u.registration_number.includes(searchTransferUser))
                ).length === 0" class="no-users-found">
                    Nenhum associado encontrado com os termos pesquisados.
                </div>
            </div>
        </section>
    </section>
</template>

<style scoped>
.bg-add-associate {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 18;
    top: 0;
    left: 0;
    background-color: white;
    overflow-y: auto;
    padding: 0px 30px;
}

.form-add-associate {
    margin-bottom: 150px;
}

.bg-add-associate .close-add-associate {
    position: absolute;
    top: 22px;
    right: 30px;
    cursor: pointer;
    font-size: 18px;
}

.form-add-associate .form-add-associate-line {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 1600px;
    margin: 0px auto;
    margin-bottom: 20px;
}

.form-add-associate .form-add-associate-line .form-add-associate-line-space {
    margin: 0px 10px;
}

.bg-cash-flow {
    width: 100%;
    height: auto;
    margin-bottom: 150px;
}

.bg-cards {
    width: 100%;
    height: auto;
    padding: 10px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.card {
    width: 250px;
    max-width: 100%;
    margin-right: 10px;
    background-color: white;
    padding: 16px 20px;
    border: 1px solid rgb(184, 184, 184);
    border-radius: 10px;
}

.card h2 {
    font-size: 18px;
    margin-bottom: 8px;
    font-weight: 500;
}

.card p {
    font-size: 22px;
    font-weight: 550;
}

.green {
    color: green;
}

.red {
    color: rgb(217, 0, 0);
}

.blue {
    color: rgb(78, 78, 255);
}

.search-button {
    width: 150px;
}

.btn .icon {
    width: 20px;
}

.filters {
    max-width: 300px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.filters .btn {
    margin-top: 25px;
}

.actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;
    max-width: 1000px;
}

#upload-statement {
    display: none;
}

@media screen and (max-width: 800px) {
    .form-add-associate .form-add-associate-line {
        flex-direction: column;
    }

    .form-add-associate .form-add-associate-line-space {
        margin: 10px 0px !important;
    }

    .filters {
        flex-direction: column;
        width: 100%;
        max-width: 100%;
    }

    .bg-cards {
        flex-direction: column;
    }

    .card {
        width: 100%;
        margin-top: 10px;
    }

    .search-button {
        width: 100%;
    }

    .filters .btn {
        margin-top: 10px;
    }

    .actions {
        flex-direction: column;
        max-width: 100%;
    }
}

/* Estilos para seleção de associado */
.form-add-associate-full-width {
    width: 100%;
}

.label-select-user {
    font-size: 16px;
    font-weight: 600;
    color: var(--primary-color);
    margin-bottom: 8px;
    display: block;
}

.selected-user-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background-color: #f0f8ff;
    border: 2px solid #C0AB61;
    border-radius: 8px;
    margin-top: 6px;
}

.selected-user-display span {
    font-size: 15px;
    color: #333;
    font-weight: 500;
}

.btn-select-user {
    width: 100%;
    padding: 12px 20px;
    background-color: #C0AB61;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s ease;
    margin-top: 6px;
}

.btn-select-user:hover {
    background-color: #a89450;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(192, 171, 97, 0.3);
}

.btn-remove-user {
    background-color: #e74c3c;
    color: white;
    border: none;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.btn-remove-user:hover {
    background-color: #c0392b;
    transform: scale(1.1);
}

/* Modal de seleção de usuário */
.select-user-modal {
    max-height: 80vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.search-user-container {
    margin-bottom: 20px;
}

.users-list-container {
    flex: 1;
    overflow-y: auto;
    max-height: 500px;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 10px;
}

.user-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    margin-bottom: 10px;
    background-color: #f9f9f9;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.user-item:hover {
    background-color: #fff;
    border-color: #C0AB61;
    box-shadow: 0 2px 8px rgba(192, 171, 97, 0.2);
}

.user-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.user-info strong {
    font-size: 15px;
    color: #333;
}

.user-details {
    font-size: 13px;
    color: #666;
}

.btn-select-this-user {
    padding: 8px 16px;
    background-color: #C0AB61;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.3s ease;
}

.btn-select-this-user:hover {
    background-color: #a89450;
}

.no-users-found {
    text-align: center;
    padding: 40px 20px;
    color: #999;
    font-size: 14px;
}

/* Z-index maior para modal de seleção aparecer sobre modal de edição */
.modal-select-paid-user {
    z-index: 20 !important;
}
</style>